'use client'

import {Button} from '@/components/ui/button'
import {Dialog, DialogClose, DialogContent, DialogFooter, DialogTitle, DialogTrigger} from '@/components/ui/dialog'
import Image from 'next/image'
import * as React from 'react'

type ProductCatalogModalProps = {
  title: string
  image: {
    url: string
    alt: string
  }
  cancelText: string
  confirmText: string
  pathToFile: string
  onConfirm?: () => void
  trigger?: React.ReactNode
}

export const ProductCatalogModal: React.FC<ProductCatalogModalProps> = ({title, image, cancelText, confirmText, pathToFile, onConfirm, trigger}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm()
    }
  }

  return (
    <Dialog>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent className="w-full max-w-sm rounded-xl text-center">
        <DialogTitle>{title}</DialogTitle>
        <div className="my-4">
          <Image src={image.url} alt={image.alt} width={300} height={400} className="rounded-lg mx-auto" />
        </div>
        <DialogFooter className="flex justify-center gap-2">
          <DialogClose asChild>
            <Button variant="secondary">{cancelText}</Button>
          </DialogClose>

          <DialogClose asChild>
            <a href={pathToFile} download target="_blank" rel="noopener noreferrer" onClick={handleConfirm}>
              <Button>{confirmText}</Button>
            </a>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
